var Engraving = class {
  constructor() {
    this.active = false;
    this.handwritingSelector = ".line-item-property--handwriting";
    this.rectoversoInput = ".product-form_rectoverso input[type='text']";
    this.engravingProductId = engravingProductId;
    this.bindEvents();
    this.buttonAddtoCart = document.querySelector("#AddToCart");
  }

  bindEvents() {
    const engrave = document.getElementById('engrave');
    if (engrave) {
      engrave.addEventListener('click', () => this.toggleClass());

      document.querySelector('.engraving_hidden_select').addEventListener('change', (e) => this.updateEngravingForm(e));
      document.querySelectorAll(this.handwritingSelector).forEach(elem => {
        elem.addEventListener('click', (e) => this.updateHandwriting(e));
      });
      document.querySelectorAll(this.rectoversoInput).forEach(elem => {
        elem.addEventListener('input', (e) => this.updateRectoVerso(e));
      });
      document.addEventListener('variant:added', (e) => this.postForm(e));

      document.addEventListener('line-item-quantity:change:end', (e) => this._onQuantityChanged(e));
      document.querySelectorAll('.cart-container .line-item__quantity a').forEach(elem => {
        elem.addEventListener('click', (e) => this._onCartDelete(e));
      });
    }
  }

  toggleClass() {
    const engravingWrapper = document.querySelector('.engraving__wrapper');
    engravingWrapper.classList.toggle('active');

    if (engravingWrapper.classList.contains('active')) {
      this.updateAddToCartButton(30);
    } else {
      this.updateAddToCartButton();
    }
  }

  updateEngravingForm(e) {
    e.preventDefault();
    const selectedValue = e.currentTarget.value;
    const rectoInput = document.querySelector('.product-form_rectoverso #input__block-recto');
    const versoInput = document.querySelector('.product-form_rectoverso #input__block-verso');
    const rectoValue = document.querySelector('.product-form_rectoverso #line-item-recto');
    const versoValue = document.querySelector('.product-form_rectoverso #line-item-verso');

    document.querySelectorAll('.product-form_rectoverso > *').forEach(elem => elem.classList.add('hidden'));

    if (selectedValue === "recto (+ 15€)") {
      rectoInput.classList.remove('hidden');
      versoValue.value = "";
      this.updateAddToCartButton(15);
    } else if (selectedValue === "verso (+ 15€)") {
      versoInput.classList.remove('hidden');
      rectoValue.value = "";
      this.updateAddToCartButton(15);
    } else if (selectedValue === "recto/verso (+ 30€)") {
      document.querySelectorAll('.product-form_rectoverso > *').forEach(elem => elem.classList.remove('hidden'));
      this.updateAddToCartButton(30);
    }

  }
  updateAddToCartButton(amount = 0) {
    const startingPrice = this.buttonAddtoCart.getAttribute('data-price-number')
    const buttonPrice = this.buttonAddtoCart.querySelector(".product-form__payment-container__price ");
    buttonPrice.textContent = ((startingPrice / 100) + amount) + "€";
  }

  updateHandwriting(e) {
    const targetElement = e.currentTarget;
    targetElement.querySelector('input').checked = true;
    document.querySelectorAll('.line-item-property--handwriting').forEach(elem => elem.classList.remove('selected'));
    targetElement.classList.add('selected');
  }

  updateRectoVerso(e) {
    const inputElement = e.currentTarget;
    const characterCountElement = inputElement.nextElementSibling.querySelector('.character-count');
    characterCountElement.textContent = inputElement.value.length;
  }

  postForm() {
    const formElement = document.querySelector('form[is="product-form"]');
    if (formElement) {
      const formData = new FormData(formElement);
      if (formData.get('id') !== this.engravingProductId) {
        const qty = ['#line-item-recto', '#line-item-verso']
          .map(selector => document.querySelector(selector)?.value)
          .reduce((count, value) => count + (value ? 1 : 0), 0);
        if (qty > 0) {
          addToCart({
            'quantity': qty,
            'id': this.engravingProductId
          });
        }
      }
    }
  }

  async _onQuantityChanged(e) {
    const engravingItem = document.querySelector(".line-item__engraving");
    if (!engravingItem) return;

    const urlToRemove = new URL(engravingItem.dataset.urlToRemove, window.location.origin);
    const id = urlToRemove.searchParams.get('id');

    const totalEngravingQty = e.detail.cart.items.reduce((sum, item) => {
      const recto = item.properties?.recto ? 1 : 0;
      const verso = item.properties?.verso ? 1 : 0;
      return sum + (recto + verso) * item.quantity;
    }, 0);

    try {
      const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id,
          quantity: totalEngravingQty,
          sections: ["mini-cart"]
        })
      });

      if (!response.ok) throw new Error('Network response was not ok');

      setTimeout(() => {
        this.reloadMiniCart(response.json());
      }, 600);
    } catch (error) {
      console.error('Failed to update engraving quantity:', error);
    }
  }

  reloadMiniCart(cartContent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  _onCartDelete(e) {
    e.preventDefault();
    const engravingItem = document.querySelector(".line-item__engraving");
    let line = engravingItem.dataset.line;
    let quantity = engravingItem.dataset.quantity - e.currentTarget.dataset.quantity * e.currentTarget.dataset.engraving;
    if (quantity < 0) quantity = 0;

    fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
      body: JSON.stringify({ line, id: null, quantity }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(() => {
      window.location.href = e.currentTarget.getAttribute('href');
    }).catch(error => console.error('Error during cart deletion:', error));
  }
};

// Initialize the Engraving class
var engraving = new Engraving();